import { render } from "./addCarouselModule.vue?vue&type=template&id=7e08a134&scoped=true"
import script from "./addCarouselModule.vue?vue&type=script&lang=js"
export * from "./addCarouselModule.vue?vue&type=script&lang=js"

import "./addCarouselModule.vue?vue&type=style&index=0&id=7e08a134&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e08a134"]])

export default __exports__